/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react'
import styles from './styles.module.css'
import {
  CircleX,
  Cross,
  Interrogation,
  // ArrowDown,
} from '../../../../assets/svgs/icons'
import Masonry from 'react-responsive-masonry'

import { MyUploadsService } from '../../../../services'
import { Loading } from '../../../../components/Loading'

import {
  notifyErrorCustom,
  // notifySuccessCustom,
} from '../../../../utils/notify'

import { useClient } from '../../../../hooks/useClient'
import { useTranslation } from 'react-i18next'

const ModalUploads = ({
  setImageUploadArray,
  closeModal,
  simpleEditModal,
  setImageLayers,
  imageLayers,
}) => {
  const { t } = useTranslation()
  const { clientData } = useClient()

  const [selectedImages, setSelectedImages] = useState([])
  const [selectedArrayImage, setSelectedArrayImage] = useState([])

  const [images, setImages] = useState([])

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    loadData()
  }, [])

  const loadData = async () => {
    const response = await MyUploadsService.getMyUploadsByPublicationIdBase64(
      clientData?.uuid || null
    )

    if (response.responseStatus === 200) {
      const images = response.data

      setImages(images)
    } else {
      notifyErrorCustom(
        t(
          'new_publication_page_campaign_step_second_pass_modal_uploads_error_message'
        )
      )
    }

    setLoading(false)
  }

  const handleImageClick = (imageUrl) => {
    const imageArray = images.find(
      (image) => image.fileBase64 === imageUrl.fileBase64
    )

    if (imageArray) {
      const arrayExists = selectedArrayImage.some(
        (arr) => JSON.stringify(arr) === JSON.stringify(imageArray)
      )

      if (arrayExists) {
        setSelectedArrayImage(
          selectedArrayImage.filter(
            (arr) => JSON.stringify(arr) !== JSON.stringify(imageArray)
          )
        )
      } else {
        setSelectedArrayImage([...selectedArrayImage, imageArray])
      }
    }

    if (selectedImages.includes(imageUrl.fileBase64)) {
      setSelectedImages(
        selectedImages.filter((image) => image !== imageUrl.fileBase64)
      )
    } else {
      setSelectedImages([...selectedImages, imageUrl.fileBase64])
    }
  }

  const handleRemoveImage = (imageArray) => {
    setSelectedArrayImage(
      selectedArrayImage.filter(
        (arr) => JSON.stringify(arr) !== JSON.stringify(imageArray)
      )
    )

    if (selectedImages.includes(imageArray.fileBase64)) {
      setSelectedImages(
        selectedImages.filter((image) => image !== imageArray.fileBase64)
      )
    } else {
      setSelectedImages([...selectedImages, imageArray.fileBase64])
    }
  }

  const addImages = async () => {
    if (simpleEditModal) {
      var imageLayersTemp = { ...imageLayers }
      const newSelectedArrayImage = selectedArrayImage.map((image) => {
        const lewLayer = {
          imageId: image.fileBase64,
          isOriginal: true,
          order: 1,
          position: [],
          sequenceEffects: [],
          type: 'image-upload',
        }

        imageLayersTemp.layer[0] = lewLayer
      })

      // return
      setImageLayers(imageLayersTemp)
    } else {
      let newSelectedArrayImage = selectedArrayImage.map((image) => {
        return {
          id: image.id,
          image:
            'data:image/' + image.fileFormat + ';base64,' + image.fileBase64,
        }
      })

      setImageUploadArray(newSelectedArrayImage)
    }

    closeModal('uploads')
  }

  return (
    <div className={styles.modal}>
      <Loading enable={loading} />
      <div className={styles.header_close}>
        <div
          className={styles.close_modal}
          onClick={() => closeModal('uploads')}
        >
          <Cross width={'20px'} height={'20px'} />
        </div>
      </div>
      <div className={styles.modal_title}>
        <h2>
          {t(
            'new_publication_page_campaign_step_second_pass_modal_uploads_title'
          )}{' '}
          <Interrogation color={'#FF8B00'} />
        </h2>
      </div>
      <div className={styles.modal_sub_title}>
        <p className={styles.modal_sub_title_text}>
          {t(
            'new_publication_page_campaign_step_second_pass_modal_uploads_subtitle'
          )}
        </p>
      </div>

      <div className={styles.container_galeyimages}>
        <Masonry columnsCount={3} gutter="10px">
          {images.map((imageUrl, i) => (
            <img
              key={i}
              src={'data:image/png;base64,' + imageUrl?.fileBase64}
              onClick={() => handleImageClick(imageUrl)}
              className={
                selectedImages.includes(imageUrl.fileBase64)
                  ? styles.selectedImage
                  : styles.image
              }
              //onContextMenu={(e) => e.preventDefault()}
            />
          ))}
        </Masonry>
      </div>

      {selectedArrayImage.length !== 0 && (
        <div className={styles.contaier_caroucel_list_selected_image}>
          <p>
            {t(
              'new_publication_page_campaign_step_second_pass_modal_uploads_selected_images'
            )}
          </p>
          <div className={styles.caroucel_list_selected_image} key={1}>
            {selectedArrayImage.map((imageArray, i) => (
              <div className={styles.card_lis_selected_image} key={i}>
                <div className={styles.container_card_lis_selected_image}>
                  <div
                    className={styles.delete_card_lis_selected_image}
                    onClick={() => handleRemoveImage(imageArray)}
                  >
                    <div style={{ cursor: 'pointer' }}>
                      <CircleX
                        color={'#FF2F00'}
                        width={'15px'}
                        height={'15px'}
                      />
                    </div>
                  </div>
                  <img
                    className={styles.item_selected_image}
                    src={'data:image/png;base64,' + imageArray.fileBase64}
                    //onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {selectedArrayImage.length !== 0 && (
        <button
          className={styles.button_add_image}
          onClick={() => {
            addImages()
          }}
        >
          {t(
            'new_publication_page_campaign_step_second_pass_modal_uploads_add_images_button'
          )}
        </button>
      )}
    </div>
  )
}

export default ModalUploads
